/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-undef */
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
  MdExpandMore,
  MdOutlineAttachMoney,
  MdOutlineFileDownload,
} from 'react-icons/md';

import { Alert } from '../../../../components/singleComponents/alerts/Alert';
import { BudgetTable } from '../../../admin/constructions/ConstructionsDetails/budgets/BudgetTable';

import api, { authHeader } from '../../../../../services/API/apiConfig';
import {
  BudgetDetailsStyled,
  ConstructionDetailsStyled,
  ContainerStyled,
  DescriptionStyled,
  DivNoDataStyled,
  ItemStyled,
  LoadingDivStyled,
  MobileStyled,
  MobileTitleStyled,
  SubItemStyled,
  TitlePageStyled,
  TotalsContainerStyled,
} from './ConstructionBudget.styles';

export function ConstructionBudgets() {
  const { id } = useParams();

  const [permission, setPermission] = useState(true);
  const [budget, setBudget] = useState(false);
  const [items, setItems] = useState([]);
  const [exportKey, setExportKey] = useState();
  const [loading, setLoading] = useState(true);
  const [constructionName, setConstructionName] = useState('');

  const exportBudget = async () => {
    await api
      .get(`constructions/${id}/budget_xlsx?export_key=${exportKey}`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { baseURL, url } = res.config;
        window.open(`${baseURL}/${url}`);
      });
  };

  useEffect(() => {
    api
      .get(`/constructions/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        setConstructionName(res.data.data.name);
        setExportKey(res.data.data.export_key);
      });
  }, []);

  useEffect(() => {
    api
      .get(`/constructions/${id}/budgets`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        if (data) {
          setPermission(true);
          setBudget(data);
          setItems(data.items_attributes);
          setLoading(false);
        }
      })
      .catch(() => {
        setPermission(false);
      });
  }, [id]);

  return (
    <>
      {permission ? (
        <>
          {budget.length === undefined ? (
            <>
              <ContainerStyled>
                <Typography
                  sx={{
                    fontSize: '24px',
                    textAlign: 'left',
                    marginBottom: '16px',
                  }}
                  variant="h1"
                >
                  {constructionName}
                </Typography>
                <BudgetTable
                  setLoading={setLoading}
                  loading={loading}
                  constructionId={id}
                />
              </ContainerStyled>
              <MobileStyled>
                <MobileTitleStyled variant="h2">Orçamento</MobileTitleStyled>
                <Typography variant="h4">Detalhes do orçamento</Typography>

                <TitlePageStyled>
                  <Typography variant="body2" color="primary">
                    {budget.construction}
                  </Typography>
                  <Button
                    variant="text"
                    color="secondary"
                    style={{ fontSize: 10 }}
                    onClick={exportBudget}
                  >
                    <MdOutlineFileDownload size={16} />
                    Exportar orçamento
                  </Button>
                </TitlePageStyled>
                {loading ? (
                  <LoadingDivStyled>
                    <CircularProgress size={24} />
                  </LoadingDivStyled>
                ) : (
                  <>
                    <ConstructionDetailsStyled>
                      <div>
                        <Typography>{`${budget.square_meters} m²`}</Typography>
                        <TotalsContainerStyled>
                          <Typography>Total orçado:&nbsp;</Typography>
                          <Typography color="secondary">
                            {new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(budget.total_budget)}
                          </Typography>
                        </TotalsContainerStyled>
                      </div>
                    </ConstructionDetailsStyled>
                    {items !== undefined &&
                      items.length &&
                      items.map((item) => (
                        <Accordion key={item.id}>
                          <AccordionSummary expandIcon={<MdExpandMore />}>
                            <ItemStyled>
                              <div className="description">
                                <Typography variant="body2">
                                  {`${item.item_num}. ${item.description}`}
                                </Typography>
                                <Typography style={{ fontSize: 10 }}>
                                  ver detalhes
                                </Typography>
                              </div>
                              <Typography className="price">{`R$ ${item.price}`}</Typography>
                            </ItemStyled>
                          </AccordionSummary>
                          {item.items_attributes.map((subItem) => (
                            <AccordionDetails key={subItem.id}>
                              <SubItemStyled>
                                <div className="title">
                                  <DescriptionStyled>
                                    <Typography>
                                      {`${item.item_num}.${subItem.item_num}`}
                                    </Typography>
                                    <Typography>
                                      {subItem.description}
                                    </Typography>
                                  </DescriptionStyled>
                                  <div className="totalPaid">
                                    <Typography>{`R$ ${subItem.total_paid}`}</Typography>
                                  </div>
                                </div>
                                {subItem.items_attributes.length ? (
                                  subItem.items_attributes.map(
                                    (tertiaryItem) => (
                                      <div
                                        className="tertiaryItem"
                                        key={tertiaryItem.id}
                                      >
                                        <DescriptionStyled>
                                          <Typography>
                                            {`${item.item_num}.${subItem.item_num}.${tertiaryItem.item_num} `}
                                          </Typography>
                                          <Typography>
                                            {tertiaryItem.description}
                                          </Typography>
                                        </DescriptionStyled>
                                        <BudgetDetailsStyled>
                                          <Typography>
                                            {`Preço unitário: ${tertiaryItem.unit_price}`}
                                          </Typography>
                                          <Typography>
                                            {`Quantidade: ${tertiaryItem.quantity} ${tertiaryItem.unit}`}
                                          </Typography>
                                        </BudgetDetailsStyled>
                                      </div>
                                    )
                                  )
                                ) : (
                                  <BudgetDetailsStyled>
                                    <Typography>
                                      {`Preço unitário: ${subItem.unit_price}`}
                                    </Typography>
                                    <Typography>
                                      {`Quantidade: ${subItem.quantity} ${subItem.unit}`}
                                    </Typography>
                                  </BudgetDetailsStyled>
                                )}
                              </SubItemStyled>
                            </AccordionDetails>
                          ))}
                        </Accordion>
                      ))}
                  </>
                )}
              </MobileStyled>
            </>
          ) : (
            <DivNoDataStyled>
              <MdOutlineAttachMoney size={200} color="#B9B9B9" />
              <Typography variant="body1" style={{ color: '#1c1c1ccc' }}>
                Nenhum orçamento adicionado até o momento.
              </Typography>
            </DivNoDataStyled>
          )}
        </>
      ) : (
        <Alert alertTitle="Orçamento indisponível" />
      )}
    </>
  );
}
